import React from "react";
import styled from "../transient-styled";

/** Fill the space inside a flex container. Component is empty, and just has a flex-grow: 1 applied */
export const FillSpace = () => <StyledFillSpace />;

const StyledFillSpace = styled.div`
    flex-grow: 1;
`;
